import { render, staticRenderFns } from "./ShiftHistoryCard.vue?vue&type=template&id=e3e08b44"
import script from "./ShiftHistoryCard.vue?vue&type=script&lang=js"
export * from "./ShiftHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports